//
//
//
//
//
//
//
//
//
//
//
//
//

import { List } from "@/models";
import ListItem from "@/components/ListItemFlex.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SelectedLists",
  created() {
    this.getLists(this.page, 20);
    if (this.listCount === 0) {
      this.loadListCount();
    }
  },
  scrollBottom() {
    this.getLists(this.page + 1, 20);
  },
  props: [],
  data() {
    return {
      lists: [],
      loading: false,
      page: 1
    };
  },
  metaInfo() {
    return {
      title: "诗单· 中华诗词库",
      titleTemplate: null
    };
  },
  methods: {
    ...mapActions(["loadListCount"]),

    getLists: function(page = 1, perPage = 15) {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      List.getSelected(page, perPage)
        .then(lists => {
          if (page == 1) {
            this.lists = lists;
          } else {
            this.lists = this.lists.concat(lists);
          }

          this.loading = false;
          this.page = page;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapGetters(["listCount"])
  },
  components: {
    ListItem
  }
};



// WEBPACK FOOTER //
// ./src/pages/Lists.vue